export default __webpack_public_path__ + "static/header-marketing-f7566b1941ed0f44768ce65b0021afed.png";